export default __webpack_public_path__ + "static/Icon_skniminners-58173bdf2c256df8df9df7353fe49646.png";